import { FormControl, FormHelperText } from "@mui/material";
import { Field } from "formik";
import { Checkbox, CheckboxWithLabel } from "formik-mui";
import React from "react";

import { FieldProps } from "./Field";

export type CheckboxFieldProps = FieldProps;

const CheckboxField = ({
	className,
	name,
	label,
	id,
	helpText,
	fullWidth = true,
	required,
	size,
	...others
}: CheckboxFieldProps) => {
	const realId = id || name;

	return (
		<FormControl
			fullWidth={fullWidth}
			variant="standard"
			hiddenLabel
			className={className}
			required={required}
		>
			{label ? (
				<Field
					id={realId}
					component={CheckboxWithLabel}
					type="checkbox"
					name={name}
					Label={{ label }}
				/>
			) : (
				<Field id={realId} component={Checkbox} type="checkbox" name={name} />
			)}
			{helpText && <FormHelperText id={`${realId}-helper-text`}>{helpText}</FormHelperText>}
		</FormControl>
	);
};

export { CheckboxField };
